import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const AsideDefaultProps = {
  ...BaseDefaultProps,
  cart: {},
};

export const AsidePropTypes = {
  ...BasePropTypes,
  cart: PropTypes.shape({
    amount_left_for_free_shipping: PropTypes.number,
    id: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    subtotal: PropTypes.number,
  }),
  isUpdated: PropTypes.bool.isRequired,
  onPutCartItems: PropTypes.func.isRequired,
};
